import { Locales } from '@/utils/language'

const KR_POPULAR_KEYWORDS = [
  '인모드리프팅',
  '인모드',
  '콧볼축소',
  '쌍꺼풀(절개)',
  '쌍꺼풀(자연유착)',
  '코끝(자가연골)',
  '코성형',
  '눈성형',
  '윤곽주사',
  '눈매교정',
  '눈재수술',
  '가슴(보형물)',
  '사각턱수술',
  '이마필러',
]

const JP_POPULAR_KEYWORDS = [
  'ダーマペン',
  'ハイフ(HIFU)',
  'ヒアルロン酸',
  'ボトックス',
  '脂肪溶解注射',
  '白玉注射',
  '糸リフト',
  'エラボトックス',
  'ルメッカ',
  'ピコトーニング',
  'ピーリング',
  '脱毛',
  'フォトフェイシャル',
  'ハイドラフェイシャル',
  '脂肪吸引',
]

const EN_POPULAR_KEYWORDS = ['Botox', 'Filler', 'Laser', 'Skin Care', 'Hair Removal']

const TH_POPULAR_KEYWORDS = ['บอทอก', 'ฟิลเลอร์', 'เลสเออร์', 'การดูแลผิว', 'การลดหนา']

const CN_POPULAR_KEYWORDS: string[] = []

export const POPULAR_KEYWORDS: Record<Locales, string[]> = {
  [Locales.KO_KR]: KR_POPULAR_KEYWORDS,
  [Locales.JA_JP]: JP_POPULAR_KEYWORDS,
  [Locales.EN_US]: EN_POPULAR_KEYWORDS,
  [Locales.TH_TH]: TH_POPULAR_KEYWORDS,
  [Locales.ZH_HANS_CN]: CN_POPULAR_KEYWORDS,
  [Locales.ZH_HANT_TW]: CN_POPULAR_KEYWORDS,
}
